<script>
import { layoutComputed } from '@/state/helpers';
import { layoutMethods } from '@/state/helpers';

import NavBar from '@/components/nav-bar';
import SideBar from '@/components/side-bar';
import RightBar from '@/components/right-bar';

import PageHeader from '@/components/page-header';

/**
 * Vertical layout
 */
export default {
  props: {
    title: {
      type: String,
      default: 'inventory.inventory',
    },
    overflow: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    NavBar,
    SideBar,
    RightBar,
    PageHeader,
  },
  created: function() {
    this.toggleMenu();

    document.body.removeAttribute('data-layout', 'horizontal');
    document.body.removeAttribute('data-topbar', 'dark');
    document.body.removeAttribute('data-layout-size', 'boxed');
  },
  mounted() {
    window.addEventListener('keydown', (event) => {
      if (event.key == 'Escape') {
        this.$emit('esc-pressed');

        let diff = Date.now() - this.lastEscTime;

        this.lastEscTime = Date.now();

        if (diff < 220) {
          this.$emit('esc-double-pressed');
          this.lastEscTime = 0;
        }
      } else if (event.key == 'Enter') {
        if (event.ctrlKey) {
          this.$emit('ctrl-enter-pressed');
        }
      } else if (event.key == 's') {
        if (event.ctrlKey) {
          event.preventDefault();
          this.$emit('ctrl-enter-pressed');
          return false;
        }
      }
    });
  },
  methods: {
    ...layoutMethods,
    toggleMenu() {
      if (this.menuCondensed) {
        document.body.classList.add('sidebar-enable');
        document.body.classList.add('vertical-collpsed');
      } else {
        document.body.classList.remove('sidebar-enable');
        document.body.classList.remove('vertical-collpsed');
      }
    },
    toggleRightSidebar() {
      document.body.classList.toggle('right-bar-enabled');
    },
    hideRightSidebar() {
      document.body.classList.remove('right-bar-enabled');
    },
  },
  computed: {
    ...layoutComputed,
  },
};
</script>

<template>
  <div id="layout-wrapper">
    <NavBar />
    <SideBar
      :is-condensed="menuCondensed"
      :type="leftSidebarType"
      :width="layoutWidth"
    />
    <!-- ============================================================== -->
    <!-- Start Page Content here -->
    <!-- ============================================================== -->

    <div class="main-content">
      <div
        style="height: 100vh; display: flex; padding: 58px 0 0 8px"
        class="page-content customScrollbarAlwaysOn"
      >
        <!-- Start Content-->
        <div
          style="
            display: flex;
            flex-direction: column;
            overflow-y: scroll;
            padding-top: 15px;
          "
          class="container-fluid"
        >
          <PageHeader :title="title" />
          <div class="main-wrapper customScrollbar">
            <div class="header-wrapper">
              <b-card style="margin-bottom: 0">
                <slot name="header"></slot>
              </b-card>
            </div>
            <div :class="`${overflow ? 'content-wrapper' : ''}`">
              <b-card style="margin-bottom: 0">
                <slot></slot>
              </b-card>
            </div>
          </div>
        </div>
      </div>
    </div>
    <RightBar />
  </div>
</template>

<style scoped>
.main-wrapper {
  margin-bottom: 20px;
  min-height: 0;
  display: flex;
  flex-direction: column;
  flex: 1 1 1px;
  position: relative;
}
.header-wrapper {
  margin-bottom: 10px;
}
.content-wrapper {
  overflow-y: auto;
}
</style>
